import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { ButtonType, Flex, SuccessAction } from '../../../../ui';
import { LoginForm } from '../../login';
import { StyledBackButton } from '../../forgottenPassword/components/styled';
import { useSidePopout } from '../../../../layout';
import { useAppDispatch, useQuery } from '../../../../hooks/appHooks';
import { ToastType } from '../../../../ui/toast';
import { LoginThunks } from '../../login/redux';
import { useToastContainer } from '../../../../layout/toastContainer';

export const TfaNotifyActionResponse: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { changePopoutContainer } = useSidePopout();
  const query = useQuery();
  const dispatch = useAppDispatch();
  const [hasError, setHasError] = useState<boolean>(false);
  const { addToast } = useToastContainer();

  useEffect(() => {
    dispatch(LoginThunks.resetTfaProviderApproved(query.get('token')!)).then(
      (res) => {
        if (res.type === 'auth/resetTfaProviderApproved/fulfilled') {
          setHasError(false);
        } else {
          setHasError(true);
          addToast({
            title: t('landingPage.tfaChoiceEmail.errorWithResendMailCodeTitle'),
            text: t(
              'landingPage.tfaChoiceEmail.errorWithResendMailCodeDescription',
            ),
            type: ToastType.Urgent,
          });
        }
      },
    );
  }, []);

  return (
    <Flex style={{ paddingTop: '70px' }}>
      <StyledBackButton
        type={ButtonType.SecondaryAction}
        text={t('landingPage.forgottenPasswordForm.backToLogin')}
        onClick={() =>
          changePopoutContainer({
            newContainer: <LoginForm />,
            urlKey: 'login',
          })
        }
      />
      {!hasError ? (
        <SuccessAction
          success
          title={t('landingPage.notifyActionsTfaProvider.responseTitle')}
          buttonText={t(
            'landingPage.notifyActionsTfaProvider.responseButtonText',
          )}
          onClick={() => {
            history.push('/');
          }}
        />
      ) : (
        <SuccessAction
          success={false}
          title={t('landingPage.notifyActionsTfaProvider.failedTitle')}
        />
      )}
    </Flex>
  );
};
